import React, { useState } from 'react';

import PaymentProcessWidget from './PaymentProcessWidget';
import SelectPaymentMethodModal from '../PaymentMethodModal/SelectPaymentMethod';

interface IPaymentProcessModal {
  paymentLink: string;
  isOnboardingApartmentSearch?: boolean;
  onSuccess?: any;
  transactionId: string;
  onClickAway: () => void;
  onBack: () => void;
  onClose: () => void;
  isShowCloseButton?: boolean;
  isInAppPreRentGuaranteePaymentApplication?: boolean;
  interacId?: number;
  amount?: number;
}

const PaymentProcessModal = ({
  paymentLink,
  isOnboardingApartmentSearch,
  onSuccess,
  transactionId,
  onClickAway,
  onBack,
  onClose,
  isShowCloseButton,
  isInAppPreRentGuaranteePaymentApplication,
  interacId,
  amount
}: IPaymentProcessModal) => {
  const [showWidget, setShowWidget] = useState(!interacId);

  if (showWidget || !interacId || !amount) {
    return (
      <PaymentProcessWidget
        paymentLink={paymentLink}
        isOnboardingApartmentSearch={isOnboardingApartmentSearch}
        onSuccess={onSuccess}
        transactionId={transactionId}
        onClickAway={onClickAway}
        onBack={onBack}
        onClose={onClose}
        isShowCloseButton={isShowCloseButton}
        isInAppPreRentGuaranteePaymentApplication={isInAppPreRentGuaranteePaymentApplication}
      />
    );
  }

  return (
    <SelectPaymentMethodModal
      interacId={interacId}
      amount={amount}
      onCardSelect={() => setShowWidget(true)}
      onClickAway={onClickAway}
      onSuccess={onSuccess}
      transactionId={transactionId}
      onClose={onClose}
    />
  );
};

export default PaymentProcessModal;
